export const PAGE_TITLE = "ECS";
export const PAGE_SINGLE_TITLE = "ECS";
export const LINK_URL = "ecss";
export const SEARCH_TERMS = ["phone", "name", "email"];
export const inputFields = {
  name: {
    type: "string",
    required: true,
    title: "Name",
  },
  email: {
    type: "string",
    required: true,
    title: "Email",
  },
  phone: {
    type: "string",
    required: true,
    title: "Phone",
  },
};
export const initialValues = {
  name: "",
  email: "",
  phone: "",
};

export const view_all_table = [
  { name: "Name", value: "name" },
  { name: "Email", value: "email" },
  { name: "Phone", value: "phone" },
];
